import React, { useEffect, useState } from "react";
import {
    Box,
    Paper,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody
} from "@mui/material";
import { apiCallUserLoginHistory } from "../../../../Core/Apicall";
import { useLocation } from "react-router-dom";
import CommonPagination from "../../../Common/CommonPagination/CommonPagination";
import CommonShimmer from "../../../Common/CommonShimmer/CommonShimmer";
import EmptyData from "../../../Common/EmptyData/EmptyData";


const LoginHistory: React.FC = () => {
    const [tableData, setTableData] = useState<any[]>([]);
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)
    const [page, setPage] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(10)

    const [totalItems, setTotalItems] = useState(0)
    const totalPages = Math.ceil(totalItems / rowsPerPage)

    const location = useLocation();
    const useData = location.state.user;

    const handleApiCall = async (userId: any) => {
        setLoading(true)
        setError(null)
        try {
            const data = {
                userId,
                offset: page,
                limit: rowsPerPage,
            };
            const res = await apiCallUserLoginHistory(data);
            setTableData(res.data);
            setTotalItems(res?.totalCount || 0)
        } catch (err) {

            setError("Failed to fetch image")
        } finally {
            setLoading(false)
        }
    };

    useEffect(() => {
        handleApiCall(useData.userId ? useData.userId : useData._id);
    }, [page, rowsPerPage, useData]);

    const handlePageChange = (value: number) => {
        setPage(value)
    }

    return (
        <Box sx={{ p: "20px" }}>
            <Paper
                className="scroll-bar"
                sx={{
                    borderRadius: 3,
                    overflow: "hidden",
                    position: "relative",
                }}
            >
                <TableContainer className="scroll-bar">
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell>Device Type</TableCell>
                                <TableCell>Login Type</TableCell>
                                <TableCell>Imei No</TableCell>
                                <TableCell>Device Name</TableCell>
                                <TableCell>Device Version</TableCell>
                                <TableCell>Last Login IP</TableCell>
                                <TableCell>Login Date</TableCell>
                            </TableRow>
                        </TableHead>
                        {loading === false &&
                            <TableBody>
                                {tableData.map((user: any) => (
                                    <TableRow key={user._id}>
                                        <TableCell>{user.deviceType || "-"}</TableCell>
                                        <TableCell>{user.loginType || "-"}</TableCell>
                                        <TableCell>{user.imeiNo || "-"}</TableCell>
                                        <TableCell>{user.deviceName || "-"}</TableCell>
                                        <TableCell>{user.deviceVersion || "-"}</TableCell>
                                        <TableCell>{user.lastLoginIP || "-"}</TableCell>
                                        <TableCell>
                                            {user.loginDate
                                                ? new Date(user.loginDate).toLocaleDateString()
                                                : "-"}
                                        </TableCell>

                                    </TableRow>
                                ))}
                            </TableBody>}

                    </Table>
                    {loading === true &&
                        <div style={{ padding: "10px 10px" }}>
                            <CommonShimmer />
                        </div>}
                    {loading === false &&
                        <EmptyData data={tableData} />}
                </TableContainer>


                <CommonPagination
                    page={page}
                    rowsPerPage={rowsPerPage}
                    totalItems={totalItems}
                    totalPages={totalPages}
                    onPageChange={(value) => handlePageChange(value)}
                    onRowsPerPageChange={(value) => {
                        setRowsPerPage(value)
                        setPage(1)
                    }}
                />
            </Paper>

        </Box>
    );
};

export default LoginHistory;